import { I18n } from 'i18n-js';

const i18n = new I18n(document.__I18NJS.translations);

i18n.fallbacks = true;
i18n.defaultLocale = document.__I18NJS.defaultLocale;
i18n.locale = document.__I18NJS.locale;

export default i18n;
